import { usingPost } from '@ocean/api'
import { UserUtils } from 'utils'
import { ChangeCommentParams } from 'modules/requirements/RequirementCompletionDetails/types'

export const setComment = (requirementId: Guid, values: ChangeCommentParams) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  const { comment } = values
  const data = {
    userId,
    competenceId: requirementId,
    comment,
  }
  return usingPost('Requirements/SetLatestCompetenceRequirementComment', data)
}
